<template>
  <v-container v-if="$can('browse', 'Country')">
    <div class="headline mb-12">
      Countries
    </div>

    <v-data-table
      :headers="headers"
      :items="countries.data"
      :loading="countries.loading"
      hide-default-footer
      disable-pagination
      class="elevation-5"
    >
      <template v-slot:item="{ item }">
        <tr
          :class="{'clickable': $can('edit', 'Country')}"
          @click="openEditCountryDialog(item.id)"
        >
          <td>
            {{ item.name }}
          </td>
          <td>
            {{ item.code }}
          </td>
          <td class="text-right">
            <v-chip
              small
              :color="item.chartering ? 'success' : 'error'"
              text-color="white"
              class="ma-0 caption"
            />
          </td>
        </tr>
      </template>
    </v-data-table>

    <country-edit-dialog
      :visible.sync="countryEditDialog"
      :country="countryDirty"
      @update:country="updateCountry"
    />
  </v-container>
</template>

<script>
import CountryEditDialog from '@/components/settings/countries/CountryEditDialog'
import { cloneDeep } from 'lodash'

export default {
  name: 'CountriesIndex',
  components: {
    CountryEditDialog
  },
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Code', value: 'code', sortable: false },
        { text: 'Chartering', value: 'chartering', sortable: false, width: '1%' }
      ],
      countryDirty: {},
      countryEditDialog: false
    }
  },
  computed: {
    countries() {
      return this.$store.state.settings.countries
    }
  },
  methods: {
    openEditCountryDialog(countryId) {
      if (!this.$can('edit', 'Country')) return

      let country = this.countries.data.find(c => c.id === countryId)
      this.countryDirty = cloneDeep(country)
      this.countryEditDialog = true
    },
    updateCountry() {

    }
  }
}
</script>
